<template>
  <span ref="badge" :style="styles">
    <slot></slot>
    <span v-if="count" v-show="badge" :class="countClasses">{{ finalCount }}</span>
    <span v-else-if="dot" :class="countClasses"></span>
  </span>
</template>
<script>
import * as constants from '../../utils/constants'

const PREFIX_BADGE_CLASS = `${constants.PREFIX_CLASS}badge`

export default {
  name: 'TBadge',
  props: {
    count: [Number, String],
    overflowCount: {
      type: [Number, String],
      default: 99
    },
    state: {
      type: String,
      validator(value) {
        let validList = [
          'success',
          'danger',
          'dark',
          'warning',
          'muted',
          'info'
        ]
        for (let i = 0; i < validList.length; i++) {
          if (value === validList[i]) {
            return true
          }
        }
        return false
      }
    },
    customClass: String,
    dot: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      alone: false
    }
  },
  computed: {
    styles() {
      if (!this.alone) {
        return 'position:relative;display:inline-block'
      }
      return ''
    },
    countClasses() {
      return [
        `${PREFIX_BADGE_CLASS}`,
        {
          [`${this.customClass}`]: !!this.customClass,
          [`${PREFIX_BADGE_CLASS}--top`]: !this.alone && !this.dot,
          [`${PREFIX_BADGE_CLASS}--${this.state}`]: this.state,
          [`${PREFIX_BADGE_CLASS}--dot`]: this.dot
        }
      ]
    },
    finalCount() {
      return parseInt(this.count) >= parseInt(this.overflowCount)
        ? `${this.overflowCount}+`
        : this.count
    },
    badge() {
      let status = false
      if (this.count) {
        status = !(parseInt(this.count) === 0)
      }
      if (this.dot) {
        status = true
        if (this.count) {
          if (parseInt(this.count) === 0) {
            status = false
          }
        }
      }
      return status
    }
  },
  mounted() {
    const childLength = this.$refs.badge.children.length
    if (childLength === 1) {
      this.alone = true
    }
  }
}
</script>



// WEBPACK FOOTER //
// badge.vue?43fb6f2c